// App.js
import React, { useState, useEffect } from "react";
import SignupLogin from "../component/BookAppointent/SignupLogin";
import CONSTANT from "../constant.json";
import axios from "axios";
import { Spin, notification } from "antd";

// _______________status____________

//    1= new user
//    2= token expire
//    3= already login
//
// _______________status____________
const Appointment = () => {
  const [currentStatus, setCurrentStatus] = useState(
    localStorage.getItem("token") ? "3" : "1"
  );
  const [isLoading, setIsLoading] = useState(false);
  const user_id = localStorage.getItem("user_id");

  let parsedBookData = null;
  try {
    const book_data = localStorage.getItem("book_data");
    parsedBookData = book_data ? JSON.parse(book_data) : null;
  } catch (e) {
    parsedBookData = null;
  }

  let parsedPhoneData = null;
  try {
    const phone_data = localStorage.getItem("phoneUpdated");
    parsedPhoneData = phone_data ? JSON.parse(phone_data) : null;
  } catch (e) {
    parsedPhoneData = null;
  }

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    console.log("Parsed Phone Data:", parsedPhoneData);
  }, []);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message,
      description,
    });
  };
  const token = localStorage.getItem("token");

  useEffect(() => {
    console.log("parsedData", parsedBookData);
  }, [localStorage.getItem("book_data")]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setCurrentStatus("3");
    } else {
      setCurrentStatus("1");
    }
  }, []);

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const bookAppointment = () => {
    if (!parsedBookData) return;
    setIsLoading(true);
    axios
      .post(
        `${CONSTANT.url}api/payment/paymentgateway`,
        {
          payamount: parsedBookData.data?.fee,
          doctor_id: parsedBookData.data?.id,
          date: parsedBookData.date,
          slot: parsedBookData?.labelSlotTime?.id,
          patient_id: user_id,
          service_type: parsedBookData?.service_type,
          promo_code: parsedBookData?.promo_code,
          patient_comment: parsedBookData?.patient_comment,
          item_id:
            Array.isArray(parsedBookData?.item_id) && parsedBookData.item_id.length > 0
              ? parsedBookData.item_id
              : parsedBookData?.item_id
              ? [parsedBookData.item_id]
              : parsedBookData?.data?.doctoritem?.[0]?.id
              ? [parsedBookData.data.doctoritem[0].id]
              : [],
          phone: parsedPhoneData,
          currency_code:
            parsedBookData?.currency_code ||
            parsedBookData?.data?.doctoritem?.[0]?.currency_code ||
            "PKR",
          ...(parsedBookData?.service_type === "home" && {
            contact_no: parsedBookData?.contact_no,
            address: parsedBookData?.address,
          }),
        },
        { headers }
      )
      .then((response) => {
        console.log("response", response);
        setIsLoading(false);

        // Check for redirect URL
        if (response?.data?.message === "redirecturl" && response?.data?.data) {
          window.location.href = response?.data?.data;
        } else if (response.data?.data) {
          // Dynamically create a form
          const form = document.createElement("form");
          form.setAttribute("method","post");
          form.setAttribute(
            "action",
            "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction"
            // "https://ipguat.apps.net.pk/Ecommerce/api/Transaction/PostTransaction"
          );

          // Add form fields based on response data
          Object.entries(response?.data?.data).forEach(([key, value]) => {
            const input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", key);
            input.setAttribute("value", value);
            form.appendChild(input);
          });

          // Append the form to the document body and submit it
          document.body.appendChild(form);
          form.submit();
          console.log("Form data response:", response?.data?.data);
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response?.data)
          if (error.response.data?.data) {
            console.log(Object.values(error.response.data?.data));
            Object.values(error.response.data?.data).map((v) =>
              openNotificationWithIcon(
                "error",
                "Error booking appointment",
                v[0]
              )
            );
          }
      });
  };

  return (
    <div className="appointments-descriptions">
      {contextHolder}
      {currentStatus === "1" || currentStatus === "2" ? (
        <SignupLogin currentStatus={currentStatus} />
      ) : parsedBookData && parsedBookData.data ? (
        <div className="appointment-container" style={{ maxWidth: "650px" }}>
          <Spin spinning={isLoading} fullscreen />

          <div className="logo"></div>
          <h2
            style={{
              fontSize: "24px",
              lineHeight: "38px",
              textAlign: "center",
              fontWeight: 800,
            }}
          >
            Appointment Details
          </h2>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {parsedBookData.data?.image_banner && (
              <img
                src={`${CONSTANT.img_url}${parsedBookData.data.image_banner}`}
                alt={parsedBookData.data.name || "Doctor"}
                style={{
                  width: "90%",
                  margin: "10px auto",
                  borderRadius: "10px",
                }}
              />
            )}
            <div
              style={{
                padding: "5%",
              }}
            >
              <p>
                <b>Name:</b> {parsedBookData.data?.name}
              </p>
              <p>
                <b>Department:</b>{" "}
                {Array.isArray(parsedBookData.data?.categories)
                  ? parsedBookData.data.categories.map((v) => v.name).join(", ")
                  : "N/A"}
              </p>

              <p>
                <b>Experience:</b> {parsedBookData.data?.experience} years
              </p>
              <p>
                <b>About:</b>
                <div
                  dangerouslySetInnerHTML={{
                    __html: parsedBookData.data?.about || "",
                  }}
                />
              </p>
              <p>
                <b>Date:</b>{" "}
                {parsedBookData?.date
                  ? new Date(parsedBookData.date).toDateString()
                  : "N/A"}
              </p>
              <p>
                <b>Time Slot:</b> {parsedBookData?.labelSlotTime?.timing || "N/A"}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: 25,
                  marginTop: 25,
                  flexWrap: "wrap",
                }}
              >
                <button
                  className="appointment-submit-btn"
                  onClick={bookAppointment}
                  style={{ marginTop: "10px" }}
                >
                  Book Now
                </button>
                <button
                  className="appointment-submit-btn"
                  onClick={() =>
                    (window.location.href =
                      "/find-your-doctor/")
                      // "https://stage.eclinicasia.com/find-your-doctor/")
                  }
                  style={{ marginTop: "10px" }}
                >
                  Get a New Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button
            style={{ maxWidth: "300px", marginTop: "30px" }}
            className="appointment-submit-btn"
            onClick={() =>
              (window.location.href =
                "/find-your-doctor")
                // "https://stage.eclinicasia.com/find-your-doctor/")
            }
          >
            Get a New Appointment
          </button>
        </div>
      )}
    </div>
  );
};

export default Appointment;
